<template>
  <div class="approval-list-wrap">
    <v-list
      v-for="(member, index) in GET_MGR_USER_LIST"
      :key="index"
      class="approval-item"
    >
      <div>
      <v-list-item class="pl-0" v-if="member.agreeSeq" :ripple="false">

        <v-list-item-content>
          <!-- 담당구분 -->
          <v-list-item-icon class="align-self-center">
            <v-chip
                label
                class="step"
                v-text="'담당'"></v-chip>
          </v-list-item-icon>
          <!-- 담당자 정보 -->
          <div class="d-flex flex-row justify-start align-center">
            <v-list-item-title
              class="name"
              v-text="member.name" >
            </v-list-item-title>
            <v-list-item-subtitle>
              <span v-text="member.mgrJikchakNm" class="position" ></span
            ><span
                v-if="member.mgrOrgNm !== ' '"
                class="divider position"
                v-text="member.mgrOrgNm"
            ></span>
            </v-list-item-subtitle>
          </div>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
          v-if="member.memo != null && member.memo != '' && member.memo != 'undefined'"
          class="pa-0"
        >
          <!-- <v-list-item-action></v-list-item-action> -->
          <v-list-item-content class="pt-0 pb-5">
            <v-sheet class="opinion-wrap" color="lightGrey">
              <v-list-item-subtitle class="opinion-title"
                >의견</v-list-item-subtitle
              >
              <div class="opinion-desc" v-html="member.memo"></div>
            </v-sheet>
          </v-list-item-content>
      </v-list-item>

      </div>
    </v-list>
  </div>
</template>

<script>
/* 참조자 리스트 */
import { mapGetters } from 'vuex';

export default {
  data: () => ({}),
  computed: {
    ...mapGetters('ELA', ['GET_MGR_USER_LIST', 'SET_MGR_USER_LIST']),
    ...mapGetters('DIALOG', ['GET_DIALOG_PARAM']),
    ...mapGetters(['GET_USER_DATA', 'GET_AUTHPG']),
  },

  mounted() {
    this.$forceUpdate();
  },

};

</script>

<style></style>
